import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=4d941328&scoped=true&"
import script from "./Vote.vue?vue&type=script&lang=ts&"
export * from "./Vote.vue?vue&type=script&lang=ts&"
import style0 from "./Vote.vue?vue&type=style&index=0&id=4d941328&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d941328",
  null
  
)

export default component.exports